// extracted by mini-css-extract-plugin
module.exports = {"dragWrapper":"captions_dragWrapper_2fC","captions":"captions_captions_HWE"};